import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  ControlItemsService
} from '../../_services/index';

import {ComplianceArea} from '../../_models/index';

import {LoginHelper, Role} from '../../helpers/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import {Constants} from "../../helpers/constants";
import {SelectWorkstreamItemComponent} from "../selectWorkstreamItem/select-workstream-item.component";
import {WorkstreamService} from "../../_services/workstream.service";

@Component({
    standalone: false,
  selector: 'map-workstream-items',
  templateUrl: 'map-workstream-items.component.html',
  styleUrls: ['./map-workstream-items.component.scss'],
})

export class MapWorkstreamItemsComponent implements OnInit {
  loading = false;
  tenantName: string;
  complianceAreaId: number;
  complianceArea: ComplianceArea;
  rowGroupMetadata: {};
  currentUser: any;
  controlItems: any;
  public workstreams: any;
  constructor(
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public controlItemsService: ControlItemsService,
    public clientProfileService: ClientProfileService,
    public complianceAreaService: ComplianceAreaService,
    public workstreamService: WorkstreamService) {
    this.complianceAreaId = route.snapshot.params['complianceAreaId'];
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    if (this.tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.clientProfileService.getWorkstreams().subscribe(r => this.workstreams = r);

    this.load();
  }

  load() {
    this.complianceAreaService.getComplianceAreas().subscribe(areas => {
        const current = areas.find(p => p.complianceAreaId == this.complianceAreaId);
        this.complianceArea = current;
      this.controlItemsService.getComplianceAreaControlItems(this.complianceAreaId, this.getTenantName()).subscribe(controlItems => {
        this.controlItems = controlItems.filter(i => !i.parentControlItemId);
        this.updateRowGroupMetaData(this.controlItems);
      });
    })
  }

  updateRowGroupMetaData(data) {
    this.rowGroupMetadata = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  deleteWsid(item, workstreamItemId) {
    this.workstreamService.removeControlItem(workstreamItemId, item.controlItemId).subscribe(() => {
      this.load();
    })
  }

  selectWsid(controlItem) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        workstreams: this.workstreams
      }
    };

      const dialogRef = this.dialog.open(SelectWorkstreamItemComponent, config);
      dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.workstreamService.addControlItem(result.workstreamItemId, controlItem.controlItemId).subscribe(() => {
          this.load();
        })
      }
    });
  }

  getTenantName(): string {
    if (this.currentUser == null) {
      return null;
    }

    if (this.currentUser.role == Role.KingAdmin) {
      return Constants.RiskSpongeMaster;
    }

    return this.currentUser.tenantName;
  }
}
